<template>
  <SelectPicker
    v-model="selected"
    api-value="/api/guides?search="
    :placeholder-value="placeholderValue"
    :label="label"
  >
    <template #image="{ selected }">
      <img
        v-if="selected"
        :src="selected.user.profile_photo_url"
        alt=""
        class="flex-shrink-0 ml-4 rounded-full h-6 w-6"
      >
    </template>
    <template #default="{ item, selected, active }">
      <span
        class="block truncate"
        :class="{ 'font-medium': selected, 'font-normal': !selected }"
      >
        <img
          :src="item.user.profile_photo_url"
          alt=""
          class="flex-shrink-0 rounded-full h-4 w-6 h-6 mr-3"
        >
      </span>

      <span
        class="block truncate mr-3 font-medium "
        :class="{ 'font-gray-900': selected, 'font-normal': !selected }"
      >
        {{ item.user.name }}
      </span>

      <span
        class="block truncate mr-3 "
        :class="{ 'font-medium': selected, 'font-light': !selected }"
      >
        {{ item.team.name }}
      </span>
    </template>
  </SelectPicker>
</template>

<script setup>
import { ref, watch } from 'vue';
import { CheckIcon } from '@heroicons/vue/24/solid';
import SelectPicker from '@/ComponentsDeprecated/Select/SelectPicker';

const props = defineProps({
  modelValue: {
    type: String,
    required: false,
    default: null,
  },
  placeholderValue: {
    type: String,
    required: false,
    default: 'Select Guide',
  },
  label: {
    type: String,
    required: false,
    default: 'Select Guide',
  },
});

const emit = defineEmits({ update: (_value) => true });
const selected = ref(props.modelValue);

watch(selected, () => {
  emit('update:modelValue', selected.value);
});

</script>
